import * as Yup from 'yup'
import { RETURN_TYPE } from 'domains/merchant-outbound-return/constants'

Yup.addMethod(Yup.array, 'unique', function(message, mapper = (a) => a) {
  return this.test('unique', message, function(list) {
    return list.length  === new Set(list.map(mapper)).size
  })
})

const MerchantOutboundReturnCreateSchema = Yup.object().shape({
  merchant    : Yup.object().required('Required'),
  return_type : Yup.string()
    .oneOf(
      Object.values(RETURN_TYPE),
      `Harus satu dari ${Object.values(RETURN_TYPE).join(', ')}`)
    .required('Required'),
  address: Yup.object().shape({
    street_address : Yup.string().required('Required'),
    kecamatan      : Yup.string().required('Required'),
    kelurahan      : Yup.string().required('Required'),
    kota           : Yup.string().required('Required'),
    provinsi       : Yup.string().required('Required'),
    kodepos        : Yup.string()
      .required()
      .matches(/^\d{5}(?:[-\s]\d{4})?$/, 'Invalid postal code')
      .min(5, 'At least 5 digits')
  }),
  items: Yup.array()
    .of(
      Yup.object().shape({
        inventory_sku: Yup.string().required('required')
      }))
    .unique('Setiap return item harus unik', (item) => item.inventory_sku)
    .required('Required')
})

export default MerchantOutboundReturnCreateSchema
